import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    versionStackNotFound: {
        /** Notification title when the version stack is not found */
        title: string;
        /** Notification details when the version stack is not found */
        details: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            versionStackNotFound: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Notification title when the version stack is not found */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useExportCompleteCallback.versionStackNotFound.title?c=246eljj2jegid", defaultMessage: "Version stack not found." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Notification details when the version stack is not found */
                        details: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useExportCompleteCallback.versionStackNotFound.details?c=22avmocdfbn9q", defaultMessage: "Exporting this sequence as a new asset." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
